import React from "react";
import { Regular7Style } from "./css/Regular7Style";
import TemplateImage from "../../components/editor/Templates/TemplateImage";
import TemplateLogo from "../../components/editor/Templates/TemplateLogo";
import TemplateWatermark from "../../components/editor/Templates/TemplateWatermark";
import TemplateText from "../../components/editor/Templates/TemplateText";

const regular_10_7 = (props) => {
  return (
    <Regular7Style>
      <div className="poster sixteen-by-nine lg">
        <TemplateLogo logo={props.logo} />
        <TemplateWatermark watermark={props.watermark} />
        <div className="img-container flex-column">
          <TemplateImage slideType={props.slideType} file={props.file} />
        </div>
        <div className="cover" />
        <div className="text-outer flex-column">
          <div className="text-wrapper subflex-left">
            <TemplateText
              id={props.id}
              text={props.text}
              textStyle={props.textStyle}
              editStatus={props.editStatus}
              onInputSlideText={props.onInputSlideText}
            />
          </div>
        </div>
      </div>
    </Regular7Style>
  );
};

export default regular_10_7;
